module.exports = __webpack_public_path__ + "img/running-red-used-car.fe2d6ee2.jpg";